/* Modulo: Compare Proof — draggable before/after reveal.
   Vanilla IIFE, reduced-motion aware, CLS-safe (position rendered server-side). */
(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ANIM_DUR_MS = 420;
  var INTRO_BOB_DELTA = 8;

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function initSection(el) {
    if (!el || el.dataset.cprInit === 'true') return;
    var frame = el.querySelector('[data-cpr-frame]');
    var handle = el.querySelector('[data-cpr-handle]');
    if (!frame || !handle) return;
    el.dataset.cprInit = 'true';

    var initial = parseFloat(el.getAttribute('data-initial'));
    if (isNaN(initial)) initial = 34;

    var pos = initial;
    var hasInteracted = false;
    var dragging = false;

    function render() {
      el.style.setProperty('--modulo-cpr-pos', pos);
      handle.setAttribute('aria-valuenow', Math.round(pos));
    }
    render();

    function setPos(p, animate) {
      pos = clamp(p, 0, 100);
      if (animate && !REDUCE) {
        el.classList.add('modulo-cpr--animating');
        window.setTimeout(function () { el.classList.remove('modulo-cpr--animating'); }, ANIM_DUR_MS + 40);
      }
      render();
    }

    function percentFromEvent(e) {
      var rect = frame.getBoundingClientRect();
      if (!rect.width) return pos;
      return ((e.clientX - rect.left) / rect.width) * 100;
    }

    function markInteracted() { hasInteracted = true; }

    // ─── Pointer drag (click-to-jump anywhere in the frame, then drag) ───
    function onPointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      var onHandle = e.target === handle || handle.contains(e.target);
      dragging = true;
      markInteracted();
      try { frame.setPointerCapture(e.pointerId); } catch (_) {}
      if (!onHandle) setPos(percentFromEvent(e), true);
    }
    function onPointerMove(e) {
      if (!dragging) return;
      setPos(percentFromEvent(e), false);
    }
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { frame.releasePointerCapture(e.pointerId); } catch (_) {}
    }

    frame.addEventListener('pointerdown', onPointerDown);
    frame.addEventListener('pointermove', onPointerMove);
    frame.addEventListener('pointerup', endDrag);
    frame.addEventListener('pointercancel', endDrag);

    // ─── Keyboard (role=slider) ───
    handle.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 10 : 5;
      var handled = true;
      switch (e.key) {
        case 'ArrowLeft':
        case 'ArrowDown': setPos(pos - step, true); break;
        case 'ArrowRight':
        case 'ArrowUp': setPos(pos + step, true); break;
        case 'Home': setPos(0, true); break;
        case 'End': setPos(100, true); break;
        case 'PageDown': setPos(pos - 20, true); break;
        case 'PageUp': setPos(pos + 20, true); break;
        default: handled = false;
      }
      if (handled) { e.preventDefault(); markInteracted(); }
    });
    handle.addEventListener('focus', markInteracted);

    // ─── One-time intro bob (skipped when reduced-motion or already used) ───
    if (!REDUCE) {
      window.setTimeout(function () {
        if (hasInteracted) return;
        setPos(clamp(initial + INTRO_BOB_DELTA, 0, 100), true);
        window.setTimeout(function () {
          if (hasInteracted) return;
          setPos(initial, true);
        }, ANIM_DUR_MS + 120);
      }, 520);
    }
  }

  function bootstrap(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-modulo-cpr]')) { initSection(scope); return; }
    var els = scope.querySelectorAll('[data-modulo-cpr]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(document); });
  } else {
    bootstrap(document);
  }

  // Theme editor: re-init the specific reloaded section.
  document.addEventListener('shopify:section:load', function (e) {
    bootstrap(e.target || document);
  });
})();
